var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "35. Layers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "35.-Layers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)",
    stroke: "#222F3E",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5152012,36.16 L1.80861194,46.0132946 C-0.567382154,47.2012917 -0.562573357,49.1211127 1.80861194,50.3067054 L43.7065892,71.255694 C46.0825833,72.4436911 49.9222255,72.4412867 52.2934108,71.255694 L94.1913881,50.3067054 C96.5673822,49.1187083 96.5625734,47.1988873 94.1913881,46.0132946 L74.4847988,36.16",
    id: "Layer-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0046097,21.7599054 C96.4789498,22.9970755 96.4745809,25.005109 94.0046097,26.2400946 L52.4801891,47.0023049 C50.005849,48.2394749 45.9897821,48.2372905 43.5198109,47.0023049 L1.99539028,26.2400946 C-0.478949844,25.0029245 -0.474580913,22.994891 1.99539028,21.7599054 L43.5198109,0.99769514 C45.994151,-0.239474922 50.0102179,-0.237290456 52.4801891,0.99769514 L94.0046097,21.7599054 Z",
    id: "Layer-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8944465,60.3103773 C16.6531499,62.4310256 10.2912051,65.611998 1.80861194,69.8532946 C-0.567382154,71.0412917 -0.562573357,72.9611127 1.80861194,74.1467054 L43.7065892,95.095694 C46.0825833,96.2836911 49.9222255,96.2812867 52.2934108,95.095694 L94.1913881,74.1467054 C96.5673822,72.9587083 96.5625734,71.0388873 94.1913881,69.8532946 C85.6501144,65.5826578 79.2441591,62.3796801 74.9735223,60.2443617",
    id: "Layer-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleLayer);
export default __webpack_public_path__ + "static/media/roleLayer.de11edca88d520b353415c9104f1ec5d.svg";
export { ForwardRef as ReactComponent };